// @ts-nocheck
import { useRequestQuery } from '../../useQueryRequest';
import { useDownloadFile } from '../../useDownloadFile';
import { useRequestPdf } from '../../useRequestPdf';
import t from '../types';

/**
 * Retrieve general ledger (GL) sheet.
 */
export function useBookAccountsSheet(query, props) {
  return useRequestQuery(
    [t.FINANCIAL_REPORT, t.BOOK_ACCOUNTS, query],
    {
      method: 'get',
      url: 'financial_statements/book-accounts',
      params: query,
      headers: {
        Accept: 'application/json+table',
      },
    },
    {
      select: (res) => res.data,
      ...props,
    },
  );
}
export const useBookAccountsSheetXlsxExport = (query, args) => {
  return useDownloadFile({
    url: 'financial_statements/book-accounts',
    config: {
      headers: {
        accept: 'application/xlsx',
      },
      params: query,
    },
    filename: 'book_of_accounts.xlsx',
    ...args,
  });
};

export const useBookAccountsSheetCsvExport = (query, args) => {
  return useDownloadFile({
    url: 'financial_statements/book-accounts',
    config: {
      headers: {
        accept: 'application/csv',
      },
      params: query,
    },
    filename: 'book_of_accounts.csv',
    ...args,
  });
};

/**
 * Retrieves the general ledger pdf document data.
 */
export function useBookAccountsPdf(query = {}) {
  return useRequestPdf({
    url: `financial_statements/book-accounts`,
    params: query
  });
}
